// Full detail responses have identical representations under both identifiers.
// Keep aliases in the existing scoped cache, with the same TTL/invalidation.
// Never seed detail entries from a partial feed, preview or search response.
export function pageResourceAliases(path, data) {
  if (/^\/api\/v1\/posts\/[^/?]+$/.test(path) && data?.id && data?.publicId != null && data?.type) {
    return [data.id, data.publicId].map(id => `/api/v1/posts/${encodeURIComponent(id)}`);
  }
  if (path !== '/api/v1/profiles/me' && /^\/api\/v1\/profiles\/[^/?]+$/.test(path) && data?.id && data?.userHandle) {
    return [data.id, data.userHandle].map(id => `/api/v1/profiles/${encodeURIComponent(id)}`);
  }
  return [];
}
